function errorDescriptionCacheKey(ot) {
    return JSON.stringify({
        s: ot.s,
        ff: ot.ff,
        rbp: ot.rbp,
    });
}
export function select_opentherm_error_description(state, boiler_type, ot_state) {
    const key = errorDescriptionCacheKey(ot_state);
    return state.ot_errcodes_cache[boiler_type]?.[key] ?? null;
}
export function opentherm_errcodes_reducer(state = {}, action) {
    switch (action.type) {
        case 'OT_ERRCODES__LOAD': {
            return {
                ...state,
                [action.boiler_type]: {
                    ...state[action.boiler_type],
                    [errorDescriptionCacheKey(action.ot_state)]: {
                        loading: true,
                        ok: false,
                        result: null,
                    },
                },
            };
        }
        case 'OT_ERRCODES__READY': {
            return {
                ...state,
                [action.boiler_type]: {
                    ...state[action.boiler_type],
                    [errorDescriptionCacheKey(action.ot_state)]: {
                        loading: false,
                        ok: action.ok,
                        result: action.result,
                    },
                },
            };
        }
        default:
            return state;
    }
}
